import React, { useEffect, useRef, useState } from "react"
import { Link } from "react-router-dom";
import { Container, Row, Col, } from 'react-bootstrap';
import Topbar from "../Components/Topbar/Topbar";
import { connect } from "react-redux";
import Sidebar from "../Components/Sidebar/Sidebar";
import LoadingSpinner from "../Components/LoadingSpinner";
import DataTable from "react-data-table-component";
import DataTableExtensions from "react-data-table-component-extensions";
import 'react-data-table-component-extensions/dist/index.css';
import Select from 'react-select';
import moment from "moment/moment";
import { createClasses, exportAllSou, exportExpiredAllSou, formatTime, getClassesList, getGroupedList, getSouList, statusText } from "../Utils/utils";
import LinearProgress from '@mui/material/LinearProgress';
import { makeStyles } from '@material-ui/core/styles';
import { toast } from "react-toastify";
import SuccessModal from "../Components/Modals/SuccessModal";
import WarningModal from "../Components/Modals/WarningModal";
import ArchiveModal from "../Components/Modals/ArchiveModal";
import config from "../config/config";
import axios from "axios";
import CustomSearch from "../Components/CustomSearch";
import { TimetoConvert } from "../Utils/TimeUtils";

const CreateClass = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [filterText, setFilterText] = useState('');
  const [regualarClasses, setRegualarClasses] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [selectedRow, setSelectedRow] = useState([]);
  const [isSuccessShow, setIsSuccessShow] = useState(false);
  const [isShow, setIsShow] = useState(false);
  const [userId, setUserId] = useState('');
  const [archiveShow, setArchiveShow] = useState(false);
  const [noteuserId, setNoteUserId] = useState('');
  const [reloadData, setReloadData] = useState(false);
  const [isShowRoll, setIsShowRoll] = useState(false);
  const [isSuccessShowRoll, setIsSuccessShowRoll] = useState(false);
  const handleFilterChange = (e) => { setFilterText(e.target.value); };



  const newTime = (time) => {
    let newMatch = time.split('&&&')
    let newArray = []
    newMatch.map((a) => {
      if (a !== "") {
        newArray.push(a)
      }
    })
    return newArray
  }

  const columns = [
    {
      id: 1,
      name: "Student Id",
      width: '105px',
      selector: (row) =>
        <div style={{
          whiteSpace: 'normal',
          wordBreak: 'break-word',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          fontSize: '12px'
        }}>
          {row.LD_SID}
        </div>
    },
    {
      id: 3,
      name: "Rank",
      cell: (row) =>
        <>
          <div className="row">
            <div className='cell-upper' style={{ fontSize: '12px' }}>{row.RANK}</div>
          </div>
        </>,
      width: "80px",
      sortable: true,
    },
    {
      id: 4,
      name: "First Name",
      cell: (row) => (
        <div style={{
          whiteSpace: 'normal',
          wordBreak: 'break-word',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          fontSize: '12px'
        }}>
          {row.FIRSTNAME}
        </div>
      ),
      sortable: true,
      width: "110px",
    },
    {
      id: 5,
      name: "Last Name",
      cell: (row) => (
        <div style={{
          whiteSpace: 'normal',
          wordBreak: 'break-word',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          fontSize: '12px'
        }}>
          {row.LASTNAME}
        </div>
      ),
      sortable: true,
      width: "110px",
    },
    {
      id: 5,
      name: "Home Email",
      cell: (row) => (
        <div style={{
          whiteSpace: 'normal',
          wordBreak: 'break-word',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          fontSize: '12px'
        }}>
          {row.HOME_EMAIL}
        </div>
      ),
      width: "200px"
    },
    // {
    //   id: 9,
    //   name: "Availability",
    //   cell: (row) =>
    //     <>
    //       <div className="row py-2">
    //         {row?.MON_FROM &&
    //           <div className='cell-up' style={{fontSize:'12px'}}>MON - {formatTime(row?.MON_FROM, row?.MON_TO)}</div>}
    //         {row?.TUE_FROM &&
    //           <div className='cell-up' style={{fontSize:'12px'}}>TUE - {formatTime(row.TUE_FROM, row.TUE_TO)} </div>}
    //         {row?.WED_FROM &&
    //           <div className='cell-up' style={{fontSize:'12px'}}>WED - {formatTime(row.WED_FROM, row.WED_TO)} </div>}
    //         {row?.THUR_FROM &&
    //           <div className='cell-up' style={{fontSize:'12px'}}>THUR - {formatTime(row.THUR_FROM, row.THUR_TO)} </div>}
    //         {row?.FRI_FROM &&
    //           <div className='cell-up' style={{fontSize:'12px'}}>FRI - {formatTime(row.FRI_FROM, row.FRI_TO)} </div>}
    //         {row?.SAT_FROM &&
    //           <div className='cell-up' style={{fontSize:'12px'}}>SAT - {formatTime(row.SAT_FROM, row.SAT_TO)} </div>}
    //         {row?.SUN_FROM &&
    //           <div className='cell-up' style={{fontSize:'12px'}}>SUN - {formatTime(row.SUN_FROM, row.SUN_TO)} </div>}
    //       </div>
    //     </>,
    //   width: "160px"
    // },
    // {
    //   id: 8,
    //   name: "Availability in EST",
    //   cell: (row) =>
    //     <>
    //       <div className="row py-2">
    //         {row?.MON_FROM &&
    //           <div className='cell-up' style={{fontSize:'12px'}}>MON - {TimetoConvert(row?.MON_FROM, row?.MON_TO, row?.TIMEZONE)}</div>}
    //         {row?.TUE_FROM &&
    //           <div className='cell-up' style={{fontSize:'12px'}}>TUE - {TimetoConvert(row.TUE_FROM, row.TUE_TO, row.TIMEZONE)} </div>}
    //         {row?.WED_FROM &&
    //           <div className='cell-up' style={{fontSize:'12px'}}>WED - {TimetoConvert(row.WED_FROM, row.WED_TO, row.TIMEZONE)} </div>}
    //         {row?.THUR_FROM &&
    //           <div className='cell-up' style={{fontSize:'12px'}}>THUR - {TimetoConvert(row.THUR_FROM, row.THUR_TO, row.TIMEZONE)} </div>}
    //         {row?.FRI_FROM &&
    //           <div className='cell-up' style={{fontSize:'12px'}}>FRI - {TimetoConvert(row.FRI_FROM, row.FRI_TO, row.TIMEZONE)} </div>}
    //         {row?.SAT_FROM &&
    //           <div className='cell-up' style={{fontSize:'12px'}}>SAT - {TimetoConvert(row.SAT_FROM, row.SAT_TO, row.TIMEZONE)} </div>}
    //         {row?.SUN_FROM &&
    //           <div className='cell-up' style={{fontSize:'12px'}}>SUN - {TimetoConvert(row.SUN_FROM, row.SUN_TO, row.TIMEZONE)} </div>}
    //       </div>
    //     </>,
    //   width: "160px"
    // },
    {
      id: 8,
      name: "Schedule in EST",
      cell: (row) =>
        <div className='' style={{ fontSize: '12px' }}>
          <div className="row pt-2 pb-3">
            {newTime(row?.selected_schedule).map((a) => (
              <>
                {a !== "" ?
                  <div className='cell-up' style={{ fontSize: '12px' }}>{a}</div>
                  : null}
              </>
            ))}
          </div>
        </div>,
      selector: (row) => row.PHONE,
      width: "150px"
    },
    {
      id: 10,
      name: "Instructor",
      selector: (row) =>
        <div style={{
          fontSize: '12px',
          whiteSpace: 'normal',
          wordBreak: 'break-word',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
        }}>
          {row.instructor_name}
        </div>,
      sortable: true,
      width: "140px"
    },
    {
      id: 9,
      name: "Timezone",
      cell: (row) => (
        <div style={{
          whiteSpace: 'normal',
          wordBreak: 'break-word',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          fontSize: '12px'
        }}>
          {row.TIMEZONE}
        </div>
      ),
      width: "150px"
    },
    {
      id: 11,
      name: "Start Date",
      sortable: true,
      cell: (row) => <div className='' style={{ fontSize: '12px' }}
        onClick={() => {
          setShowModal(true)
          setSelectedRow(row)
        }}>{moment(row.new_start_date).format('MM/DD/YYYY')}</div>,
      ignoreRowClick: true,
      allowOverflow: true,
      width: "100px"
    },
    {
      id: 12,
      name: "End Date",
      sortable: true,
      cell: (row) => <div className='' style={{ fontSize: '12px' }}
        onClick={() => {
          setShowModal(true)
          setSelectedRow(row)
        }}>{(row.COURSE_NUMBER).split('-')[1]?.startsWith('30')
          ? moment(row.new_start_date).add(3, 'weeks').format('MM/DD/YYYY')
          : moment(row.new_start_date).add(10, 'weeks').format('MM/DD/YYYY')
        }</div>,
      ignoreRowClick: true,
      allowOverflow: true,
      width: "100px"
    },
    {
      id: 14,
      name: "Course No.",
      sortable: true,
      width: "125px",
      cell: (row) => <div style={{ fontSize: '12px' }}
      >{row.serialized_course_number}</div>,
      ignoreRowClick: true,
      allowOverflow: true,
    },
    {
      id: 15,
      name: "Course Type",
      selector: (row) =>
        <div style={{
          whiteSpace: 'normal',
          wordBreak: 'break-word',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          fontSize: '12px'
        }}>
          {row.COURSETYPE}
        </div>,
      ignoreRowClick: true,
      allowOverflow: true,
      width: "110px"
    },
    {
      id: 16,
      name: "Uploaded On",
      cell: (row) => (
        <div style={{
          whiteSpace: 'normal',
          wordBreak: 'break-word',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          fontSize: '12px'
        }}>
          {moment(row.created_on).format('MM/DD/YYYY hh:mm a')}
        </div>
      ),
      sortable: true,
      width: "120px"
    },
    {
      id: 19,
      name: "SOU Signed on ",
      cell: (row) => <div className='cell-link' style={{ fontSize: '12px' }}
      >{row.sou_signed_on == null ? '' : moment(row.sou_signed_on).format('MM/DD/YYYY')}</div>,
      ignoreRowClick: true,
      allowOverflow: true,
      width: "110px"
    },
    {
      id: 19,
      name: "Notes",
      cell: (row) => <div className='' style={{ padding: '10px', fontSize: '12px' }}
      >{row.notes}</div>,
      ignoreRowClick: true,
      allowOverflow: true,
      width: "150px"
    },
    {
      id: 20,
      name: "Action",
      width: "160px",
      cell: (row) =>
        <div className='cell-link'>
          <>
            <i className="text-warning fas fa-hourglass mr-2" title="Create Class"
              onClick={() => {
                setUserId(row?.id)
                setIsShow(true)
              }}></i>

            <i className="text-danger fas fa-undo mr-2" title="Undo"
              onClick={() => {
                setUserId(row?.id)
                setIsShowRoll(true)
              }}></i>
            <i className="text-info fas fa-archive ml-3" title="Archive"
              onClick={() => {
                setArchiveShow(true)
                setNoteUserId(row?.LD_SID)
              }}></i>

          </>
        </div>,
      // selector: (row) => <><i class="far fa-sticky-note"></i> <i class="fas fa-archive"></i></>,
    },
  ];

  const getAllClass = async () => {
    setIsLoading(true)
    var res = await getClassesList(6)
    if (res.status == 200) {
      setRegualarClasses(res?.data)
      setIsLoading(false)
    }
  }
  useEffect(() => {
    getAllClass()
    // setPageCount(data.length / maxPageLimit)
  }, [reloadData])

  const useStyles = makeStyles(theme => ({
    root: {
      width: '50%',
      '& > * + *': {
        marginTop: theme.spacing(2),
      },
    },
  }));
  const LinearIndeterminate = () => {
    const classes = useStyles();

    return (
      <div className={classes.root}>
        <LinearProgress />
      </div>
    );
  };
  const onSubmit = async () => {
    setIsLoading(true)
    try {
      var res = await createClasses(userId)
      if (res?.status == 200) {
        setIsLoading(false)
        setIsSuccessShow(true)
        getAllClass()
      }
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  }
  const onProceed = () => {
    setIsShow(false)
    onSubmit()
  }
  const onClose = () => {
    setIsSuccessShow(false)
    // let aprArr = []
    // approvedArr.map((apr) => {
    //   aprArr.push(apr.mainClassNumber)
    // })
    // const filteredArray = regualarClasses.filter(item => !aprArr.includes(item.mainClassNumber));
    // setRegualarClasses(filteredArray)
  }
  const removeStudent = async (id) => {
    var token = localStorage.getItem('access_token');
    let path = config.siteUrl;
    await axios.post(path + '/classes/rollback-student', {
      id: id
    }, {
      headers: { 'content-Type': 'application/json', Authorization: `${token}` },
    })
      .then((response) => {
        setIsShowRoll(false)
        setIsSuccessShowRoll(true)
      })
      .catch((error) => {
        console.log(error)
      });
  }
  const onProceedRoll = async () => {
    removeStudent(userId)
  }

  const conditionalRowStyles = [
    {
      when: row => row.space_a_ind === 'T',
      style: {
        backgroundColor: '#fb6f46',
        color: 'black',
        '&:hover': {
          backgroundColor: '#FDB7A2 !important',
          cursor: 'pointer',
        },
      },
    },
  ];

  const onCloseRoll = () => {
    setIsSuccessShowRoll(false)
    getAllClass()
  }
  return (
    <>
      <LoadingSpinner isLoading={isLoading} />
      <div className="main-div">
        <div className="blue-back"></div>
        <Row className="w-100 m-auto">
          {/* <Col md={2}>
            <Sidebar />
          </Col> */}
          <Col md={12} className="right-pad">
            <div className="main-text">
              <Topbar />
              <div>
                <div className={'new-card'} style={{ padding: "20px 15px 30px 15px" }}>
                  <div className='top-row'>
                    <div className="row">
                      <div className="col-lg-9">
                        <div className='heading-text'>
                          Create Class
                        </div>
                      </div>
                      <div class="col-lg-3">
                        <CustomSearch filterText={filterText} onFilter={handleFilterChange} />
                      </div>
                    </div>
                  </div>
                  <div>
                    <div className="row mb-4 mt-1">
                      <div className="col-md-12">
                        {regualarClasses.length > 0 ?
                          <div className="card m-overflow-h todo-card-list sou-list" style={{ border: 'none' }}>
                            <div className="card-body m-p-0 data-tab filter-tab p-0">
                              <DataTableExtensions
                                columns={columns}
                                data={regualarClasses.filter((item) => Object.values(item).some((value) => String(value).toLowerCase().includes(filterText.toLowerCase().trim())))}
                                print={false}
                                export={false}
                                filter={false}
                              >
                                <DataTable
                                  pagination
                                  // paginationComponentOptions={paginationComponentOptions}
                                  // selectableRows
                                  conditionalRowStyles={conditionalRowStyles}
                                  // selectableRowsNoSelectAll={true}
                                  // onSelectedRowsChange={({ selectedRows }) => setSelectRowsArr(selectedRows)}
                                  persistTableHead
                                  // progressPending={isLoading}
                                  progressComponent={<LinearIndeterminate />}
                                  paginationPerPage={10}
                                  paginationRowsPerPageOptions={[10, 25, 50, 100]}
                                  highlightOnHover
                                  className="custom-table-border"
                                  customStyles={{
                                    headCells: {
                                      style: {
                                        backgroundColor: '#8A8A8A',
                                        color: '#ffffff',
                                      },
                                    },
                                  }}
                                />
                              </DataTableExtensions>
                            </div>
                          </div>
                          :
                          <div className="no-record">
                            There are no records to display.
                          </div>
                        }
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Col>
        </Row>
        {isSuccessShow == true ?
          <SuccessModal
            isSuccessShow={isSuccessShow}
            setIsSuccessShow={setIsSuccessShow}
            onClose={onClose}
          />
          : null}
        {isShow == true ?
          <WarningModal
            isShow={isShow}
            setIsShow={setIsShow}
            onProceed={onProceed}
          />
          : null}
        {archiveShow == true ?
          <ArchiveModal
            archiveShow={archiveShow}
            setArchiveShow={setArchiveShow}
            noteUserId={noteuserId}
            setReloadData={setReloadData}
          />
          : null}
        {isShowRoll == true ?
          <WarningModal
            isShow={isShowRoll}
            setIsShow={setIsShowRoll}
            onProceed={onProceedRoll}
          />
          : null}
        {isSuccessShowRoll == true ?
          <SuccessModal
            isSuccessShow={isSuccessShowRoll}
            setIsSuccessShow={setIsSuccessShowRoll}
            onClose={onCloseRoll}
          />
          : null}
      </div>
    </>
  )
}
export default CreateClass